"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbilityUsedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AbilityUsedEventArgs {
    constructor(args) {
        this.args = args;
        this.__type = EventType_1.EventType.AbilityUsed;
        this.__typeName = "AbilityUsed";
    }
}
exports.AbilityUsedEventArgs = AbilityUsedEventArgs;
